export const colorData = [
  {
    text: "黑色",
    color: "#454A53",
  },
  {
    text: "白色",
    color: "#FFFFFF",
  },
  {
    text: "灰色",
    color: "#CCD1D8",
  },
  {
    text: "柠檬黄色",
    color: "#FFEE5F",
  },
  {
    text: "黄绿色",
    color: "#9ED469",
  },
  {
    text: "绿色",
    color: "#46B05A",
  },
  {
    text: "天蓝色",
    color: "#4EC1E8",
  },
  {
    text: "蓝色",
    color: "#5E9CED",
  },
  {
    text: "黄色",
    color: "#F7BB42",
  },
  {
    text: "橙色",
    color: "#FB7E52",
  },
  {
    text: "纸黄色",
    color: "#CFA972",
  },
  {
    text: "浅咖啡色",
    color: "#7E6B5A",
  },
  {
    text: "深褐色",
    color: "#4B3831",
  },
  {
    text: "粉红色",
    color: "#FBACC6",
  },
  {
    text: "玫红色",
    color: "#EE3C6E",
  },
  {
    text: "大红色",
    color: "#EC2F2F",
  },
  {
    text: "浅紫色",
    color: "#AC92ED",
  },
  {
    text: "深紫色",
    color: "#4F3493",
  },
];
